import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4a4d79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "label" }

interface Props {
  disabled?: boolean
  active?: boolean
  label?: string
  icon?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VMenuButton',
  props: {
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    label: { default: '' },
    icon: { default: '' }
  },
  emits: ['navigate'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-menu-button", [{ active: __props.active, disabled: __props.disabled }]]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!__props.active ? _ctx.$emit('navigate') : null), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
  ], 2))
}
}

})